import { render } from "./FormLabel2.vue?vue&type=template&id=37603f28"
import script from "./FormLabel2.vue?vue&type=script&lang=js"
export * from "./FormLabel2.vue?vue&type=script&lang=js"

import "./FormLabel2.vue?vue&type=style&index=0&id=37603f28&lang=sass"

import exportComponent from "D:\\Open Server 5.3.5\\OSPanel\\domains\\front\\personal_form\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__